var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import TransactionUtils from '@popup/steem/utils/transaction.utils';
import { Asset as CommonAsset } from '@steempro/steem-keychain-commons';
import moment from 'moment';
import { KeychainError } from 'src/keychain-error';
import Logger from 'src/utils/logger.utils';
// Helper per estrarre type/value dal op (gestisce sia array che object)
const extractOp = (op) => {
    if (Array.isArray(op)) {
        return { type: op[0], value: op[1] };
    }
    return { type: (op === null || op === void 0 ? void 0 : op.type) || 'unknown', value: (op === null || op === void 0 ? void 0 : op.value) || {} };
};
const fetchTransaction = (username, curr, startDate, endDate, feedBack) => __awaiter(void 0, void 0, void 0, function* () {
    const MAX_LIMIT = 10000;
    const lastTransaction = yield TransactionUtils.getLastTransaction(username, curr);
    if (!startDate)
        startDate = moment().subtract(1, 'day').toDate();
    if (!endDate)
        endDate = moment().toDate();
    let start = lastTransaction;
    let limit = Math.min(start, MAX_LIMIT);
    let rawTransactions = [];
    let operations = [];
    let forceStop = false;
    let percentageDuration;
    if (startDate) {
        percentageDuration = endDate.getTime() - new Date(startDate).getTime();
    }
    try {
        do {
            rawTransactions = (yield TransactionUtils.getTransactions(username, curr, start, limit));
            for (let i = rawTransactions.length - 1; i >= 0; i--) {
                const tx = rawTransactions[i];
                const { type: operationType, value: operationPayload } = extractOp(tx.op);
                const transactionInfo = tx;
                const dateString = moment(transactionInfo.time * 1000);
                const localDatetime = dateString.format('yyyy-MM-DD HH:mm:ss');
                if (endDate &&
                    dateString.isSameOrAfter(moment(endDate).add(1, 'day'), 'day')) {
                    continue;
                }
                if (startDate && dateString.isAfter(moment(startDate), 'day')) {
                    forceStop = true;
                    break;
                }
                const operation = {
                    operationType: operationType,
                    datetime: localDatetime,
                    transactionId: transactionInfo.id.toString(),
                    blockNumber: transactionInfo.block_num,
                    to: 'NA',
                    amount: 0,
                    currency: 'NA',
                    from: 'NA',
                };
                switch (operationType) {
                    case 'transfer': {
                        const transferOperation = operationPayload;
                        const asset = CommonAsset.fromString(transferOperation.amount.toString());
                        operations.push(Object.assign(Object.assign({}, operation), { from: transferOperation.from, to: transferOperation.to, amount: asset.amount, currency: asset.symbol }));
                        break;
                    }
                    case 'interest': {
                        const asset = CommonAsset.fromString(operationPayload.interest.toString());
                        operations.push(Object.assign(Object.assign({}, operation), { from: 'NA', to: operationPayload.owner, amount: asset.amount, currency: asset.symbol }));
                        break;
                    }
                    case 'transfer_to_vesting': {
                        const asset = CommonAsset.fromString(operationPayload.amount.toString());
                        operations.push(Object.assign(Object.assign({}, operation), { from: operationPayload.from, to: operationPayload.to, amount: asset.amount, currency: asset.symbol }));
                        break;
                    }
                    case 'fill_vesting_withdraw': {
                        const asset = CommonAsset.fromString(operationPayload.deposited.toString());
                        operations.push(Object.assign(Object.assign({}, operation), { from: operationPayload.from_account, to: operationPayload.to_account, amount: asset.amount, currency: asset.symbol }));
                        break;
                    }
                    case 'fill_convert_request': {
                        let asset = CommonAsset.fromString(operationPayload.amount_out.toString());
                        operations.push(Object.assign(Object.assign({}, operation), { from: operationPayload.owner, to: operationPayload.owner, amount: asset.amount, currency: asset.symbol }));
                        asset = CommonAsset.fromString(operationPayload.amount_in.toString());
                        operations.push(Object.assign(Object.assign({}, operation), { from: operationPayload.owner, to: operationPayload.owner, amount: asset.amount, currency: asset.symbol }));
                        break;
                    }
                    case 'producer_reward': {
                        let asset = CommonAsset.fromString(operationPayload.vesting_shares.toString());
                        operations.push(Object.assign(Object.assign({}, operation), { to: operationPayload.producer, amount: asset.amount, currency: asset.symbol }));
                        break;
                    }
                    case 'claim_reward_balance': {
                        let asset = CommonAsset.fromString(operationPayload.reward_steem.toString());
                        if (asset.amount > 0)
                            operations.push(Object.assign(Object.assign({}, operation), { to: operationPayload.account, amount: asset.amount, currency: asset.symbol }));
                        asset = CommonAsset.fromString(operationPayload.reward_sbd.toString());
                        if (asset.amount > 0)
                            operations.push(Object.assign(Object.assign({}, operation), { to: operationPayload.account, amount: asset.amount, currency: asset.symbol }));
                        asset = CommonAsset.fromString(operationPayload.reward_vests.toString());
                        if (asset.amount > 0)
                            operations.push(Object.assign(Object.assign({}, operation), { to: operationPayload.account, amount: asset.amount, currency: asset.symbol }));
                        break;
                    }
                    case 'escrow_release': {
                        let asset = CommonAsset.fromString(operationPayload.sbd_amount.toString());
                        if (asset.amount > 0)
                            operations.push(Object.assign(Object.assign({}, operation), { to: operationPayload.to, from: operationPayload.from, amount: asset.amount, currency: asset.symbol }));
                        asset = CommonAsset.fromString(operationPayload.steem_amount.toString());
                        if (asset.amount > 0)
                            operations.push(Object.assign(Object.assign({}, operation), { to: operationPayload.to, from: operationPayload.from, amount: asset.amount, currency: asset.symbol }));
                        break;
                    }
                    case 'account_create':
                    case 'account_create_with_delegation': {
                        let asset = CommonAsset.fromString(operationPayload.fee.toString());
                        if (asset.amount > 0)
                            operations.push(Object.assign(Object.assign({}, operation), { from: operationPayload.creator, amount: asset.amount, currency: asset.symbol }));
                        break;
                    }
                    case 'proposal_pay': {
                        let asset = CommonAsset.fromString(operationPayload.payment.toString());
                        if (asset.amount > 0)
                            operations.push(Object.assign(Object.assign({}, operation), { to: operationPayload.receiver, from: operationPayload.payer, amount: asset.amount, currency: asset.symbol }));
                        break;
                    }
                    case 'fill_order': {
                        let asset = CommonAsset.fromString(operationPayload.current_pays.toString());
                        if (asset.amount > 0)
                            operations.push(Object.assign(Object.assign({}, operation), { to: operationPayload.open_owner, from: operationPayload.current_owner, amount: asset.amount, currency: asset.symbol }));
                        asset = CommonAsset.fromString(operationPayload.open_pays.toString());
                        if (asset.amount > 0)
                            operations.push(Object.assign(Object.assign({}, operation), { to: operationPayload.current_owner, from: operationPayload.open_owner, amount: asset.amount, currency: asset.symbol }));
                        break;
                    }
                    default:
                        Logger.log(`missing ${operationType}`);
                        break;
                }
            }
            let percentage;
            if (startDate && percentageDuration) {
                const tx = rawTransactions[rawTransactions.length - 1];
                const transactionInfo = tx;
                const date = moment(moment(transactionInfo.time * 1000) + 'z').toDate();
                const passedDuration = endDate.getTime() - date.getTime();
                percentage = (passedDuration / percentageDuration) * 100;
            }
            else {
                const index = lastTransaction - rawTransactions[rawTransactions.length - 1].id;
                percentage = (index / lastTransaction) * 100;
            }
            if (feedBack)
                feedBack(percentage);
            start = Math.min(start - MAX_LIMIT, rawTransactions[0].id - 1);
        } while (start > MAX_LIMIT && !forceStop);
        return operations;
    }
    catch (err) {
        Logger.error('Error while fetching transactions', err);
    }
    return undefined;
});
const generateCSV = (operations) => {
    var _a;
    let csvContent = `Operation Type,Date,Transaction ID, Block number,From,To,Amount,Currency\r\n`;
    for (const operation of operations) {
        csvContent += `${operation.operationType},${operation.datetime},${operation.transactionId},${operation.blockNumber},${(_a = operation.from) !== null && _a !== void 0 ? _a : 'NA'},${operation.to},${operation.amount},${operation.currency}\r\n`;
    }
    return csvContent;
};
const downloadTransactions = (username, currency, startDate, endDate, feedback) => __awaiter(void 0, void 0, void 0, function* () {
    const operations = yield fetchTransaction(username, currency, startDate, endDate, feedback);
    if (!operations) {
        throw new KeychainError('export_transactions_fetching_error');
    }
    const csv = generateCSV(operations);
    var data = new Blob([csv], {
        type: 'text/plain',
    });
    var url = window.URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${username}-transactions-${startDate || 'start'}-${endDate || moment().format('YYYY-MM-DD')}.csv`;
    a.click();
});
export const ExportTransactionUtils = { downloadTransactions };
